import { link } from './styles.module.scss';

export const BackLink = ({ children, ...other }) => {
  return (
    <button className={link} {...other}>
      {children}
    </button>
  );
};
